import { useState, useMemo } from 'react';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';

type Props = {
  title: string;
  maxDailyWage?: number;
  minDailyWage?: number;
};

export const DailyWageInput = ({ title, maxDailyWage, minDailyWage }: Props) => {
  const maxDailyWageValueWithComma = useMemo(() => {
    return maxDailyWage ? maxDailyWage.toLocaleString('ja') : '';
  }, [maxDailyWage]);
  const minDailyWageValueWithComma = useMemo(() => {
    return minDailyWage ? minDailyWage.toLocaleString('ja') : '';
  }, [minDailyWage]);

  const [maxDailyWageValue, setMaxDailyWageValue] = useState(maxDailyWageValueWithComma);
  const [minDailyWageValue, setMinDailyWageValue] = useState(minDailyWageValueWithComma);
  const { dispatch } = useRecruitmentListContext();

  const onChangeMaxDailyWage = (s: string) => {
    setMaxDailyWageValue(s);

    dispatch({
      type: 'changeMaximumDailyWage',
      payload: { maximumDailyWage: s === '' ? null : Number(s) },
    });
  };
  const onChangeMinDailyWage = (s: string) => {
    setMinDailyWageValue(s);

    dispatch({
      type: 'changeMinimumDailyWage',
      payload: { minimumDailyWage: s === '' ? null : Number(s) },
    });
  };

  return (
    <>
      <div className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray">
        <span className="text-sm font-normal text-black">{title}</span>
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="下限"
            value={minDailyWageValue}
            onBlur={() => {
              setMinDailyWageValue(minDailyWageValueWithComma);
            }}
            onFocus={() => {
              setMinDailyWageValue(minDailyWage ? minDailyWage + '' : '');
            }}
            onChange={(e) => {
              onChangeMinDailyWage(e.target.value);
            }}
          />
          <span className="tilde">~</span>
          <input
            type="text"
            placeholder="上限"
            value={maxDailyWageValue}
            onBlur={() => {
              setMaxDailyWageValue(maxDailyWageValueWithComma);
            }}
            onFocus={() => {
              setMaxDailyWageValue(maxDailyWage ? maxDailyWage + '' : '');
            }}
            onChange={(e) => {
              onChangeMaxDailyWage(e.target.value);
            }}
          />
        </div>
      </div>

      <style jsx>{`
        .tilde {
          margin: 0 20px;
        }
        input {
          width: 4.5rem;
          outline: none;
          font-family: 'Hiragino Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          text-align: center;
          color: #4d5253;
        }
        .input-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: space-between;
        }
      `}</style>
    </>
  );
};
